import { getDocument } from "@faire/globals/browser/getDocument";
import { useEffect, useRef } from "react";

type IOptions = Record<string, undefined | ((event: KeyboardEvent) => void)>;

export const useHandleKeyDown = (options: IOptions) => {
  const refOptions = useRef(options);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const handler = refOptions.current[event.key];
      handler?.(event);
    };

    getDocument()?.addEventListener("keydown", handleKeyDown);
    return () => {
      getDocument()?.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};
